<div class="page">
  <div class="title-btn-container">
    <div class="title">{{ 'store.vouchers.title' | translate }}</div>
    <div class="btns-container">
      <button (click)="createNewVoucher(-1)">
        <img src="assets/images/add-btn.png" alt="">
        {{ 'store.vouchers.create' | translate }}
      </button>
    </div>
  </div>
  <div class="vouchers-filters-container">
    <div class="inputs-container">
      <app-select [selectedItem]="params.inStock" [options]="inStock"
                  (changeSelect)="changeStockFilter($event)"></app-select>
      <div class="search-container">
        <img src="assets/images/search.svg">
        <input
          [(ngModel)]="params.search"
          (keyup.enter)="doSearchByEnter($event);"
          (keyup)="doSearchByKeyUp($event);"
          [placeholder]="'store.vouchers.searchPlaceholder' | translate" type="text">
      </div>
      <div style="display: flex;align-content: center">
        <app-select style="margin-inline-end: 5px" [selectedItem]="params.status" [options]="statusList"
                    (changeSelect)="changeFilter($event)"></app-select>
        <div style="font-size: 12px ;display: flex;align-items: center">
          {{ 'store.vouchers.title' | translate }}
        </div>
      </div>
    </div>
    <div class="totals-container">
      <div class="totals-stats">
        <div class="value">{{stateCount}}</div>
        <div class="label">{{ 'store.vouchers.title' | translate }}</div>
      </div>
      <div class="totals-stats">
        <div class="value">{{stateTotal}}</div>
        <div class="label">{{ 'store.vouchers.availableCodes' | translate }}</div>
      </div>
    </div>

  </div>
  <div class="mobile-only mobile-table" *ngIf="dataList?.length">
    <div class="mobile-table__card" *ngFor="let item of dataList; let i = index">
      <div class="mobile-table__header">
        <div>
          <div class="mobile-table__title-group">
            <img class="mobile-table__thumb" [src]="item.logoImageUrl" alt="">
            <div class="mobile-table__title">{{item.title}}</div>
          </div>
          <div  class="mobile-table__meta"><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></div>
        </div>
        <div class="mobile-table__actions">
          <button
            class="mobile-table__action-btn"
            [placement]="'bottom'"
            [outsideClick]="true"
            #pop="bs-popover"
            [popover]="popTemplateMobile"
            [attr.aria-label]="'common.actions' | translate"
          >
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <ng-template #popTemplateMobile>
            <div class="mobile-table__menu-item mobile-table__menu-item--divider" (click)="goToDetails(item)">
              {{ 'store.vouchers.edit' | translate }}
            </div>
            <div class="mobile-table__menu-item" (click)="openGenerate(item.id,template,pop)"> {{ 'store.vouchers.generateCodes' | translate }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="mobile-table__rows">
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.vouchers.availableCodes' | translate }}</div>
          <div class="mobile-table__value">
            <span *ngIf="item.codesCount != '0'">{{item.codesCount}}</span>
            <span *ngIf="item.codesCount == '0'" style="color: #ff3b30">{{ 'store.vouchers.outOfStock' | translate }}</span>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'common.status' | translate }}</div>
          <div class="mobile-table__value">
            <div [class]="item.status">{{item.status | titlecase}}</div>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.vouchers.table.value' | translate }}</div>
          <div  class="mobile-table__value"><span class="ltr-text">{{item.voucherValue | currency: item?.currency?.code : 'code'}}</span></div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.vouchers.table.price' | translate }}</div>
          <div  class="mobile-table__value"><span class="ltr-text">{{item.price | currency: item?.currency?.code : 'code'}}</span></div>
        </div>
      </div>
    </div>
  </div>
  <div class="empty-list mobile-only" *ngIf="!dataList?.length">{{ 'store.vouchers.empty' | translate }}</div>
  <div class="table-wrapper desktop-only">
    <table class="table AgentsTable">
      <thead>
      <tr>
        <th>{{ 'store.vouchers.table.image' | translate }}</th>
        <th>{{ 'store.vouchers.table.name' | translate }}</th>
        <th>{{ 'store.vouchers.table.createdCode' | translate }}</th>
        <th>{{ 'store.vouchers.availableCodes' | translate }}</th>
        <th>{{ 'common.status' | translate }}</th>
        <th>{{ 'store.vouchers.table.value' | translate }}</th>
        <th>{{ 'store.vouchers.table.price' | translate }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of dataList; let i = index">
        <td>
          <img [src]="item.logoImageUrl" style="width: 50px;" alt="">
        </td>
        <td>{{item.title}}</td>
        <td ><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></td>
        <td>
          <div *ngIf="item.codesCount != '0'"> {{item.codesCount}}</div>
          <div style="color: #ff3b30" *ngIf="item.codesCount == '0'"> {{ 'store.vouchers.outOfStock' | translate }}</div>
        </td>
        <td>
          <div [class]="item.status">
            {{item.status | titlecase}}
          </div>
        </td>
        <td ><span class="ltr-text">{{item.voucherValue | currency: item?.currency?.code : 'code'}}</span></td>
        <td ><span class="ltr-text">{{item.price | currency: item?.currency?.code : 'code'}}</span></td>
        <td class="dots-container">
          <button
            [placement]="'left'"
            [outsideClick]="true"
            #pop="bs-popover"
            [popover]="popTemplate"
          >
            <i
              class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>

          <ng-template #popTemplate>
            <div class="mobile-table__menu-item mobile-table__menu-item--divider" (click)="goToDetails(item)">
              {{ 'store.vouchers.edit' | translate }}
            </div>
            <div class="mobile-table__menu-item" (click)="openGenerate(item.id,template,pop)"> {{ 'store.vouchers.generateCodes' | translate }}
            </div>
          </ng-template>
        </td>
      </tr>
      </tbody>

    </table>
    <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.vouchers.empty' | translate }}</div>

  </div>
  <div class="table-footer">
    <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
                    (nextClicked)="nextClick($event)"></app-pagination>
    <app-export-csv [disabled]="!dataList?.length" path="web/vouchers/csv" [params]="params"></app-export-csv>
  </div>
  <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
</div>
<ng-template #template>
  <div *ngIf="!redeemDone">

    <div class="modal-header">
      <img src="assets/images/x-modal.svg" (click)="modalRef?.hide()" alt="">
      <h5>{{ 'store.vouchers.generateTitle' | translate }}</h5>
    </div>
    <div class="modal-body">
      <div class="label">{{ 'store.vouchers.quantity' | translate }}</div>
      <div class="input-container">
        <input [(ngModel)]="redeemCode" oninput="validity.valid||(value='');" min="0" type="number" placeholder="100">
        <div *ngIf="invalidCode" style="color: red;font-size: 13px">{{ 'store.vouchers.invalidCode' | translate }}</div>
      </div>
      <button [disabled]="!redeemCode" (click)="generateCode()" class="redeem-btn">{{ 'store.vouchers.generate' | translate }}</button>
    </div>
  </div>
  <div class="redeemed-container" *ngIf="redeemDone">
    <img src="assets/images/success_icon.png">
    <h5>{{ 'store.vouchers.generated' | translate }}</h5>
    <div style="font-size: 13px;
font-weight: 400;
font-style: normal;
color: #262626;
text-align: center;">
      {{ 'store.vouchers.generatedNote' | translate: { count: redeemCode } }}
    </div>
    <button class="done-btn" (click)="onDone()">{{ 'common.done' | translate }}</button>
  </div>
</ng-template>
